export default {
  setStreams({ getters, commit }, streams) {
    if (streams.length >= 0) {
      commit('SET_STREAMS', streams)
    }
  }
}
